import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyVehicleAllResponse, RegisterUserPayload, RegisterUserResponse, VehicleData, VehicleDefaultPayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { InformationResponse, InsertLicensePayload, InsertLicenseResponse, StatusAPIResponse, UpdateLicensePayload } from "../../../models/information.model";
import { CorrectLicenseCardsPayload } from "../../../models/parking_card/parkingCard.model";

@Injectable({
    providedIn: 'root',
})

export class ApiLicenseService {
    private tokenUrl = `${environment.apiPrivateUrl}`;

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private apiMethods: ApiMethodService,
    ) { }


    insertLicense(
        data: InsertLicensePayload,
        token: string,
    ): Observable<InsertLicenseResponse> {
        const body = data;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        // console.log('Sent Api Insert License : ', headers, body);
        console.log('Sent Api Insert License : ', this.tokenUrl + '/Cityparking/insert_license ', body);
        return this.http.post<InsertLicenseResponse>(
            this.tokenUrl + '/Cityparking/insert_license ',
            body,
            {
                headers,
            },
        );
    }

    postCorrectLicenseCards(
        token: string,
        payload: CorrectLicenseCardsPayload,
    ): Observable<StatusAPIResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    console.log(
      '📨 Sent Api Correct License Cards : ',
      this.tokenUrl + '/Cityparking/CorrectLicenseCards',
      headers,
      payload,
    );

    return this.http.post<StatusAPIResponse>(
      this.tokenUrl + '/Cityparking/CorrectLicenseCards',
      payload,
      {
        headers,
      },
    );
  }

    editLicenseDefault(
        data: VehicleDefaultPayload,
        token: string,
    ): Observable<InsertLicenseResponse> {
        const body = data;
        const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        });
        return this.http.post<InsertLicenseResponse>(
        this.tokenUrl + '/Cityparking/Edit_license_Default ',
        body,
        {
            headers,
        },
        );
    }
}
